<div
  *ngFor="let error of validationErrors$ | async"
  class="alert-messages-container"
  data-testid="tray-alert-message-container"
>
  <div *ngIf="error.hasError" class="row">
    <div class="alert warning w-100">
      {{error.errorMessage}}
    </div>
  </div>
</div>


